<div class="px-1 py-1 space-y-1 text-center">
  @for (item of menu(); track $index) {
  <div>
    <app-widget-box name="{{item.name}}" description="{{item.description}}" [dark]="true">
      <div class="flex flex-wrap gap-1 justify-center mx-auto">
        @for (route of item.routes; track $index) {
        <div class="w-52">
          <app-widget-option [value]="route.name" [active]="page() == route.id" (clicked)="navigateToPage(route.id)">
          </app-widget-option>
        </div>
        }
      </div>
    </app-widget-box>
  </div>
  }
</div>